var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cadastro-simples-form',{attrs:{"endpoint":"tipo-documento-anexo","rota-base":"/admin/tipo-documento-anexo","titulo-singular":"Tipo de Documento Anexo","campos-extras":[
        { campo: "descricao", label: "Descrição", tipo: "text" }
    ]}})
}
var staticRenderFns = []

export { render, staticRenderFns }